import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=ffe8d81c&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=ffe8d81c&prod&scoped=true&lang=css"
import style1 from "./Templates.vue?vue&type=style&index=1&id=ffe8d81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8d81c",
  null
  
)

export default component.exports